import PropTypes from 'prop-types';
import {lazy} from 'react';
import {connect} from 'react-redux';
import Surface from '../../../UI/Surface/Surface';
import GenericFallbackSuspense from '../../../v2/components/ui/GenericFallback/GenericFallbackSuspense';
import {isCollapsibleExperiment} from '../../../v2/selectors/ExperimentSelectors';

const MarketingPreferencesContainer = lazy(() => import('./MarketingPreferencesContainer'));

export function MarketingPreferencesLazyLoader(props) {
  if (props.hidden) {
    return null;
  }
  
  return (
    <GenericFallbackSuspense fallback={<span />}>
      <Surface>
        <MarketingPreferencesContainer />
      </Surface>
    </GenericFallbackSuspense>
  );
}

MarketingPreferencesLazyLoader.propTypes = {
  isStepActive: PropTypes.bool.isRequired,
  hidden: PropTypes.bool.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  hidden: !ownProps.isStepActive && isCollapsibleExperiment(state),
});

export default connect(mapStateToProps)(MarketingPreferencesLazyLoader);
